module.exports = __webpack_public_path__ + "img/749DCBE9905D3846.67d005a4.png";